<template>
  <div id="app">
    <div v-if="!showThanks" id="map">
      <!-- <img src="../public/Legende_neu.png" id="legend"> -->
      <img src="https://www.psychomusic.de/standanmeldung/Legende_neu.png" id="legend">
      <div id="mapbox" v-dragscroll>
        <!-- <img src="../public/Karte_neu.png"> -->
        <img src="https://www.psychomusic.de/standanmeldung/Karte_neu.png">
        <v-touch v-on:tap="handleTooltip($event, spot)" v-for="(spot,idx) in spots" :key="idx">
          <div
            v-bind:class="{ spot: true, free: spot.state === 'frei', reserved: spot.state === 'reserviert', occupied: spot.state === 'belegt' }" 
            v-bind:style="{ left: spot.posX + 'px', top: spot.posY + 'px' }" 
            v-tooltip="{ autoHide: false, hideOnTargetClick: false, show: spot.showTooltip, trigger:'hover', placement: 'left', content: getTooltipContent(spot) }"
            >{{spot.name}}
          </div>
        </v-touch>
      </div>
      <div id="formbox">
        <h2>Anmeldung</h2>
        <label for="name" :class="{error: nameError}">Name</label>
        <input 
          type="text" 
          name="name" 
          maxlength="100" 
          v-model="name"
          @keydown="checkNameError"
          @change="checkNameError"/>
        <div class="errorContainer"><span class="error" v-if="nameError">Bitte gib uns etwas mehr Infos...</span></div>

        <label for="address" :class="{error: addressError}">Anschrift</label>
        <input 
          type="text" 
          name="address" 
          maxlength="200" 
          placeholder="Strasse Hausnummer"
          v-model="address"
          @keydown="checkAddressError"
          @change="checkAddressError"/>
        <div class="errorContainer"><span class="error" v-if="addressError">Bitte gib uns etwas mehr Infos...</span></div>

        <label for="email" :class="{error: mailError}">Email</label>
        <input 
          type="email" 
          name="email" 
          maxlength="100" 
          v-model="email"
          @keydown="checkMailError"
          @change="checkMailError"/>
        <div class="errorContainer"><span class="error" v-if="mailError">Bitte gib eine gültige Email ein</span></div>

        <label for="beschreibung" :class="{error: descriptionError}">Standbeschreibung (max. 100 Zeichen)</label>
        <input 
          type="text" 
          name="beschreibung" 
          maxlength="100" 
          v-model="description"
          @keydown="checkDescriptionError"
          @change="checkDescriptionError"/>
        <div class="errorContainer"><span class="error" v-if="descriptionError">Bitte gib uns etwas mehr Infos...</span></div>

        <input 
          style="display:inline;margin-right:15px;width:auto;"
          type="checkbox" 
          name="accept" 
          v-model="accept"/>
        <label style="display:inline;" for="accept" :class="{error: sent && !accept}">Ich habe die <a target="_blank" href="https://www.psychomusic.de/standanmeldung/festtagsordnung.pdf">Festordnung</a> gelesen und akzeptiere sie.</label>

        <label :class="{ error: spotError}">ausgewählte Standplätze (ca. 3x3m):</label>
        <div class="hint">1 großer Stand -&gt; bis zu 3 nebeneinander auswählen<br>mehre Stände -&gt; mehrere seperate Anmeldungen</div>
        <span class="pickedSpots" v-for="(spot,idx) in pickedSpots" :key="idx">{{spot.name}}</span>
        <div class="errorContainer"><span class="error" v-if="spotError">Bitte wähle min. 1 und max. 3 Standplätze aus</span></div>
        <br/><br/>
        <button :disabled="invalid" @click="sendForm">Absenden</button>
        <div class="error" v-if="sendError">Fehler beim absenden. Bitte kontaktieren Sie uns: <b>rudolf-verein@gmx.de</b></div>
      
        <div class="copyright">&copy; 2023 by <a target="_blank" href="https://rudolfverein.noblogs.org/">Rudolf e.V.</a></div>
      </div>
    </div>
    <div v-if="showThanks" id="thanks">
      <h2>Danke für deine Anmeldung</h2>
      <p>Deine Auswahl ist reserviert und wird von uns in Kürze geprüft.<br/>
      Wenn es Rückfragen gibt, melden wir uns!</p>
      <p><button @click="reload">zurück zur Karte</button></p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import myCaptcha from 'vue-captcha'
import { dragscroll } from 'vue-dragscroll'

var axios = require('axios');
// var apiBaseUrl= 'http://localhost/standanmeldung/src';
var apiBaseUrl= '/standanmeldung';

export default {
  name: 'app',
  directives: {
    'dragscroll': dragscroll
  },
  components: {
    'v-captcha': myCaptcha
  },
  created: function(){
    let component = this;
    axios.get(apiBaseUrl+'/api/getData.php').then(function (response) {
        response.data.map(i => { i.showTooltip = false; i.active = false;});
        component.spots = response.data;
    });
  },
  computed: {
    invalid() {
      return !this.description.length || !this.email.length  || !this.name.length  || !this.address.length  || 
      this.descriptionError || this.nameError || this.mailError || this.addressError || !this.accept;
    }
  },
  methods: {
    reload() {
      location.reload();
    },
    sendForm() {
      let component = this;
      this.sent = true;
      if(!this.invalid && this.pickedSpots.length <= 3 && this.pickedSpots.length > 0) {
        var params = new URLSearchParams();
        params.append('username', this.name);
        params.append('email', this.email);
        params.append('address', this.address);
        params.append('description', this.description);
        params.append('spots', JSON.stringify(this.pickedSpots));
        axios.post(apiBaseUrl+'/api/reservation.php',params,{
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function () {
            component.showThanks = true;
        })
        .catch(function () {
            component.sendError = true;
        });
      } else {
        this.spotError = true;
      }
    },
    handleTooltip(event, spot) {
      this.spots.map(i => Vue.set(i,'showTooltip', false));
      Vue.set(spot,'showTooltip', true);
      this.spotClick (event, spot);
    },
    spotClick (event, spot) {
      if(spot.state === 'frei'){
        event.target.classList.toggle("active");
        spot.active = !spot.active;
        if(spot.active) {
          this.pickedSpots.push(spot);
          this.spotError = false;
        } else {
          let foundIdx = this.pickedSpots.indexOf(this.pickedSpots.find((s) => s.id === spot.id));
          this.pickedSpots.splice(foundIdx,1);
        }
      }
    },
    checkMailError: function(){
      this.mailError = !/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(this.email);
    },
    checkNameError: function(){
      this.nameError = this.name.length < 3;
    },
    checkAddressError: function(){
      this.addressError = this.address.length < 3;
    },
    checkDescriptionError: function(){
      this.descriptionError = this.description.length < 3;
    },
    getTooltipContent: function(spot){
      let tooltip = '';
      if(spot.state !== 'frei') {
        tooltip += '<div class="state ' + spot.state + '">' + spot.state + '</div><br/>';
        tooltip += 'Von: ' + spot.username + '<br/><br/>';
        tooltip += spot.content;
      }
      return tooltip;
    }
  },
  data () {
    return {
      spots: [],
      email: "",
      name: "",
      address: "",
      accept: false,
      description: "",
      nameError: false,
      addressError: false,
      mailError: false,
      descriptionError: false,
      spotError: false,
      sendError: false,
      showThanks: false,
      sent: false,
      pickedSpots: []
    }
  }
}
</script>

<style>
h2 {
  margin-top: 0;
}
input, button {
  font-size: 18px;
}
#legend {
  position: fixed;
  top: 30px;
  left: 30px;
  z-index: 10;
}
#thanks {
  width: 100%;
  margin-top: 100px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 18px;
}
#map {
  display: flex;
}
#mapbox {
  position: relative;
  width: 75vw;
  height: 100vh;
  overflow: scroll;
}
  #mapbox img{
    position: absolute;
    left: 0;
  }
  #mapbox .spot{
    position: absolute;
    width: 30px;
    height: 30px;
    /*border-radius: 25px;*/
    cursor: pointer;
    border: 4px solid;
    line-height: 2em;
    font-weight: bold;
    font-size: 16px;
  }
    #mapbox .spot.free {
      background: rgba(0,200,0,0.8);
    }
    #mapbox .spot.reserved {
      background: rgba(250,220,100,0.8);
    }
    #mapbox .spot.occupied {
      background: rgba(200,0,0,0.8);
    }
    #mapbox .spot.active {
      border-color: white;
    }
  #formbox {
    width: 25vw;
    padding: 20px;
  }
    #formbox div {
      width: 100%;
    }
    #formbox label {
      text-align: left;
      display: block;
      margin-top: 20px;
      font-size: 14px;
    }
    #formbox input {
      width: 100%;
    }
    #formbox .error {
      color: #DD0000;
    }
    #formbox .errorContainer {
      height: 1em;
      font-size: 12px;
      text-align: left;
    }

    .tooltip {
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      background: #333333;
      color: white;
      padding: 20px;
      margin-right: 12px;
      max-width: 200px;
      z-index: 20;
    }
    .tooltip:after {
      content: '';
      width: 20px;
      height: 20px;
      background: #333333;
      display: block;
      position: absolute;
      bottom: 50%;
      right: -10px;
      transform: translateY(50%) rotate(45deg);
    }
    .tooltip .state {
      margin-bottom: -10px;
      padding-bottom: 0;
      font-weight: bold;
    }
    .tooltip .reserviert {
      color: #FFDD00;
    }
    .tooltip .belegt {
      color: #FF0000;
    }
    .pickedSpots {
      font-weight: bold;
      margin: 0 10px;
    }
    .hint {
      font-size: 11px;
      text-align: left;
    }
    .copyright {
      font-size: 14px;
      margin-top: 40px;
    }
</style>
